export default __webpack_public_path__ + "static/media/nowEdge.ef429ea5.png";